import { ICenterFiveStarWeightedAverageResults, INetworkFiveStarSurvey } from '@nkr/models/index';

interface IProps {
    detail: INetworkFiveStarSurvey
}

const NetworkFiveStarSurveyDataRow = (props: IProps) => {
    let rowDetail = props.detail;
    let total = props.detail;

    let overallBgColor = total.centerOverallAverage  < 4.95 ? "pink" : "lime";
    let workupTreatmentBgColor = rowDetail.workupTreatment.centerAverageN != 0 && rowDetail.workupTreatment.networkAverageN != 0 ? rowDetail.workupTreatment.networkDiff < 0 ? "pink" : "lime" : "";
    let workupConvenienceBgColor = rowDetail.workupConvenience.centerAverageN != 0 && rowDetail.workupConvenience.networkAverageN != 0 ? rowDetail.workupConvenience.networkDiff < 0 ? "pink" : "lime" : "";
    let workupFacilityBgColor = rowDetail.workupFacility.centerAverageN != 0 && rowDetail.workupFacility.networkAverageN != 0 ? rowDetail.workupFacility.networkDiff < 0 ? "pink" : "lime" : "";
    let preopTreatmentBgColor = rowDetail.preOpTreatment.centerAverageN != 0 && rowDetail.preOpTreatment.networkAverageN != 0 ? rowDetail.preOpTreatment.networkDiff < 0 ? "pink" : "lime" : "";
    let preopConvenienceBgColor = rowDetail.preOpConvenience.centerAverageN != 0 && rowDetail.preOpConvenience.networkAverageN != 0 ? rowDetail.preOpConvenience.networkDiff < 0 ? "pink" : "lime" : "";
    let preopFacilityBgColor = rowDetail.preOpFacility.centerAverageN != 0 && rowDetail.preOpFacility.networkAverageN != 0 ? rowDetail.preOpFacility.networkDiff < 0 ? "pink" : "lime" : "";
    let surgeryTreatmentBgColor = rowDetail.surgeryTreatment.centerAverageN != 0 && rowDetail.surgeryTreatment.networkAverageN != 0 ? rowDetail.surgeryTreatment.networkDiff < 0 ? "pink" : "lime" : "";
    let surgeryConvenienceBgColor = rowDetail.surgeryConvenience.centerAverageN != 0 && rowDetail.surgeryConvenience.networkAverageN != 0 ? rowDetail.surgeryConvenience.networkDiff < 0 ? "pink" : "lime" : "";
    let surgeryFacilityBgColor = rowDetail.surgeryFacility.centerAverageN != 0 && rowDetail.surgeryFacility.networkAverageN != 0 ? rowDetail.surgeryFacility.networkDiff < 0 ? "pink" : "lime" : "";
    let postSurgerySurgeonBgColor = rowDetail.postSurgerySurgeon.centerAverageN != 0 && rowDetail.postSurgerySurgeon.networkAverageN != 0 ? rowDetail.postSurgerySurgeon.networkDiff < 0 ? "pink" : "lime" : "";
    let postSurgeryNursingBgColor = rowDetail.postSurgeryNursing.centerAverageN != 0 && rowDetail.postSurgeryNursing.networkAverageN != 0 ? rowDetail.postSurgeryNursing.networkDiff < 0 ? "pink" : "lime" : "";
    let postSurgeryPainManagementBgColor = rowDetail.postSurgeryPainManagement.centerAverageN != 0 && rowDetail.postSurgeryPainManagement.networkAverageN != 0 ? rowDetail.postSurgeryPainManagement.networkDiff < 0 ? "pink" : "lime" : "";
    let postSurgeryCareTakerTreatmentBgColor = rowDetail.postSurgeryCaretakerTreatment.centerAverageN != 0 && rowDetail.postSurgeryCaretakerTreatment.networkAverageN != 0 ? rowDetail.postSurgeryCaretakerTreatment.networkDiff < 0 ? "pink" : "lime" : "";

    return (
        <tr>
            <td style={{ paddingLeft: "8px" }}>{rowDetail.centerAlias}</td>
       
            {total.centerOverallAverage != 0 ?
                <td style={{ backgroundColor: overallBgColor }}>{total.centerOverallAverage.toFixed(1)}</td>
                :
                <td>--</td>
            }

            {rowDetail.workupTreatment.centerAverage != 0 ?
                <td style={{ backgroundColor: workupTreatmentBgColor }}>{rowDetail.workupTreatment.centerAverage.toFixed(1) + '(' + rowDetail.workupTreatment.centerAverageN + ')'}</td>
                :
                <td>--</td>
            }

            {rowDetail.workupConvenience.centerAverage != 0 ?
                <td style={{ backgroundColor: workupConvenienceBgColor }}> {rowDetail.workupConvenience.centerAverage.toFixed(1) + '(' + rowDetail.workupConvenience.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.workupFacility.centerAverage != 0 ?
                <td style={{ backgroundColor: workupFacilityBgColor }}> {rowDetail.workupFacility.centerAverage.toFixed(1) + '(' + rowDetail.workupFacility.centerAverageN + ')'} </td>
                :
                <td>--</td>
            }

            {rowDetail.preOpTreatment.centerAverage != 0 ?
                <td style={{ backgroundColor: preopTreatmentBgColor }}> {rowDetail.preOpTreatment.centerAverage.toFixed(1) + '(' + rowDetail.preOpTreatment.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.preOpConvenience.centerAverage != 0 ?
                <td style={{ backgroundColor: preopConvenienceBgColor }}> {rowDetail.preOpConvenience.centerAverage.toFixed(1) + '(' + rowDetail.preOpConvenience.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.preOpFacility.centerAverage != 0 ?
                <td style={{ backgroundColor: preopFacilityBgColor }}> {rowDetail.preOpFacility.centerAverage.toFixed(1) + '(' + rowDetail.preOpFacility.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.surgeryTreatment.centerAverage != 0 ?
                <td style={{ backgroundColor: surgeryTreatmentBgColor }}> {rowDetail.surgeryTreatment.centerAverage.toFixed(1) + '(' + rowDetail.surgeryTreatment.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.surgeryConvenience.centerAverage != 0 ?
                <td style={{ backgroundColor: surgeryConvenienceBgColor }}> {rowDetail.surgeryConvenience.centerAverage.toFixed(1) + '(' + rowDetail.surgeryConvenience.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.surgeryFacility.centerAverage != 0 ?
                <td style={{ backgroundColor: surgeryFacilityBgColor }}> {rowDetail.surgeryFacility.centerAverage.toFixed(1) + '(' + rowDetail.surgeryFacility.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.postSurgerySurgeon.centerAverage != 0 ?
                <td style={{ backgroundColor: postSurgerySurgeonBgColor }}> {rowDetail.postSurgerySurgeon.centerAverage.toFixed(1) + '(' + rowDetail.postSurgerySurgeon.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.postSurgeryNursing.centerAverage != 0 ?
                <td style={{ backgroundColor: postSurgeryNursingBgColor }}> {rowDetail.postSurgeryNursing.centerAverage.toFixed(1) + '(' + rowDetail.postSurgeryNursing.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.postSurgeryPainManagement.centerAverage != 0 ?
                <td style={{ backgroundColor: postSurgeryPainManagementBgColor }}> {rowDetail.postSurgeryPainManagement.centerAverage.toFixed(1) + '(' + rowDetail.postSurgeryPainManagement.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }

            {rowDetail.postSurgeryCaretakerTreatment.centerAverage != 0 ?
                <td style={{ backgroundColor: postSurgeryCareTakerTreatmentBgColor }}> {rowDetail.postSurgeryCaretakerTreatment.centerAverage.toFixed(1) + '(' + rowDetail.postSurgeryCaretakerTreatment.centerAverageN + ')'}  </td>
                :
                <td>--</td>
            }
        </tr>
    )
}

export default NetworkFiveStarSurveyDataRow;